module.exports = __webpack_public_path__ + "partylineManage/img/Conference.ba6c6f78.png";